import styled, { css } from 'styled-components'
import DocumentListCard from '~/components/Cards/DocumentListCard'

export const AccordionContainer = styled(DocumentListCard)`
  padding: 8px;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    padding: 16px;
  }
`

export const AccordionSummary = styled.summary`
  list-style: none;
  display: inline-flex;
  gap: 6px;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 8px 0;

  &::-webkit-details-marker {
    display: none;
  }
`

export const AccordionDetails = styled.details`
  display: flex;
  flex-direction: column;
`

export const AccordionItem = styled.section<{
  disabled: boolean
  $defaultOpened?: boolean
}>`
  display: flex;
  flex-direction: column;

  ${({ disabled, $defaultOpened }) =>
    disabled
      ? css`
          summary {
            cursor: default;
          }

          summary > figure {
            outline: none;
          }
        `
      : css`
          details[open] > summary > figure {
            transform: rotate(180deg);
          }
          ${$defaultOpened &&
          css`
            details[open] > summary > figure {
              transform: rotate(0deg);
            }
            details:not([open]) > summary > figure {
              transform: rotate(180deg);
            }
          `}
        `}
`
export const AccordionContent = styled.div``

export const Separator = styled.hr<{ isLastOne: boolean }>`
  border: 0;
  width: 100%;
  border-top: 1px solid #abbed1;
  margin: ${({ isLastOne }) => (isLastOne ? '12px 0 0' : '12px 0')};
`

export const AccordionHeaderButton = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
`
